<div class="filter-wrapper">
  <div class="ag-multi-select-title">{{'app.general.filter' | translate}}</div>
  <app-multi-select [list]="list" [selected]="workingSelection()" (resetFilter)="resetFilter()" (selectionChange)="onSelectionChanged($event)" />

  <div class="multi-select-actions">
    <app-general-button
      [buttonStyle]="'primary'"
      [buttonHeight]="32"
      [buttonName]="'app.general.approval'"
      (buttonClicked)="applyFilter()"
    />
    <app-general-button
      [buttonStyle]="'secondary'"
      [buttonHeight]="32"
      [buttonName]="'app.general.cancel'"
      (buttonClicked)="resetFilter()"
    />
  </div>
</div>
